import { createUseStyles } from 'react-jss';
import redHeartGift from '../../../static/images/red-heart-gift.png';

const useStyles = createUseStyles({
  logo: {
    position: 'absolute',
    height: 52,
    width: 266,
    margin: [[50, 0, 0, 50]],
    transition: [['all', '0.2s']],
  },
  wideBackgroundContainer: {
    height: 780,
    background: `linear-gradient(to left, #fff 0%, #fff 76%, #edeeee 39%, #edeeee 100%)`,
  },
  slimBackgroundContainer: {
    height: 1200,
    background: `linear-gradient(to bottom, #fff 0%, #fff 70%, #edeeee 39%, #edeeee 100%)`,
  },
  heroContainer: {
    width: '85%',
    maxWidth: 1440,
  },
  heroCopy: {
    minWidth: 545,
    maxWidth: 660,
  },
  heroHeader: {
    fontWeight: 600,
    fontSize: 64,
  },
  heroSubHeader: {
    fontSize: 18,
    lineHeight: 1.35,
  },
  redHeartGift: {
    height: 380,
    minWidth: 428,
    maxWidth: 445,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'contain',
    backgroundImage: `url(${redHeartGift})`,
  },
  '@media (min-width: 1200px)': {
    heroCopy: {
      marginLeft: -48,
    },
    slimBackgroundContainer: {
      display: 'none',
    },
  },
  '@media (min-width: 1441px)': {
    heroCopy: {
      marginLeft: '6%',
    },
  },
  '@media (max-width: 992px)': {
    logo: {
      position: 'relative',
      display: 'block',
      margin: [[20, 'auto', -48]],
      height: 28,
      width: 170,
    },
  },
  '@media (max-width: 768px)': {
    heroHeader: {
      fontSize: 'inherit',
      width: '85%',
      margin: [[0, 'auto']],
      display: 'block',
    },
    heroSubHeader: {
      maxWidth: 530,
      fontSize: 'inherit',
      width: '85%',
      margin: [[0, 'auto']],
      display: 'block',
    },
    slimBackgroundContainer: {
      height: 861,
    },
  },
  '@media (max-width: 576px)': {
    heroHeader: {
      fontSize: 32,
    },
    heroSubHeader: {
      maxWidth: 530,
      display: 'block',
    },
    slimBackgroundContainer: {
      height: 861,
    },
  },
});

export default useStyles;
